import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import HRDashboard from './hrms/HRDashboard';
import ITDashboard from './it/ITDashboard';
import FinanceDashboard from './finance/FinanceDashboard';
import EmployeeDashboard from './employee/EmployeeDashboard';
import CEODashboard from './ceo/CEODashboard';
import { theme } from '../theme';

function SuperAdminDashboard() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div style={{ background: `linear-gradient(135deg, ${theme.dark}, ${theme.darkSecondary})`, borderRadius: '0.75rem', padding: '2rem', color: theme.white }}>
        <h1 style={{ margin: '0 0 0.5rem', fontSize: '1.75rem', fontWeight: 800 }}>Super Admin Dashboard</h1>
        <p style={{ color: '#9CA3AF', margin: 0 }}>Full system access — Bonton Suite</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
        {[
          { label: 'User Management', desc: 'Manage system users and roles', icon: '👥', link: '/admin/users' },
          { label: 'HR Module', desc: 'Employees, Leave, Attendance', icon: '🏢', link: '/hrms/employees' },
          { label: 'IT Module', desc: 'Assets, Licenses, Tickets', icon: '💻', link: '/it/assets' },
          { label: 'Finance Module', desc: 'Claims and Reports', icon: '💰', link: '/finance/claims' },
        ].map((item, i) => (
          <a key={i} href={item.link}
            style={{ display: 'block', background: theme.white, borderRadius: '0.75rem', padding: '1.5rem', border: `1px solid ${theme.border}`, textDecoration: 'none', boxShadow: '0 1px 3px rgba(0,0,0,0.07)', transition: 'all 0.15s' }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = theme.primary; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.transform = 'none'; }}
          >
            <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>{item.icon}</div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, color: theme.text, margin: '0 0 0.25rem' }}>{item.label}</h3>
            <p style={{ fontSize: '0.8rem', color: theme.textMuted, margin: 0 }}>{item.desc}</p>
          </a>
        ))}
      </div>
    </div>
  );
}

function Dashboard() {
  const { user } = useAuth();

  switch (user?.role) {
    case 'super_admin':
      return <SuperAdminDashboard />;
    case 'hr_admin':
      return <HRDashboard />;
    case 'it_admin':
      return <ITDashboard />;
    case 'finance_team':
    case 'finance_head':
      return <FinanceDashboard />;
    case 'ceo':
    case 'cfo':
    case 'cto':
      return <CEODashboard />;
    case 'employee':
    case 'reporting_manager':
    default:
      return <EmployeeDashboard />;
  }
}

export default Dashboard;
